module.exports = {"chips":[{"multiplier":1,"assetChip":"systemIcons/chips/chip_0.svg"},{"multiplier":5,"assetChip":"systemIcons/chips/chip_1.svg"},{"multiplier":10,"assetChip":"systemIcons/chips/chip_2.svg"},{"multiplier":25,"assetChip":"systemIcons/chips/chip_3.svg"},{"multiplier":50,"assetChip":"systemIcons/chips/chip_4.svg"}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/configurations/chipsConfig.json
// module id = 672
// module chunks = 0